export default "__VITE_ASSET__BshUMxg4__"